export default {
  agree: "I Agree"
};
